import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Button,
  IconButton,
} from "@mui/material";
import Station from "../../assets/img/station.png";
import "./stationDetails.scss";
import Modal from "@mui/material/Modal";
import ContactModal from "./contactModal";
import { Close } from "@mui/icons-material";
// Removed unused import
import SwiperCarousel from "../SwiperCarousel";
import { fetchStationImages } from "../../lib/helper";
const formatPaymentTypes = (paymentTypes) => {
  if (!paymentTypes) return "N/A";

  // Handle new PaymentTypes object structure
  if (typeof paymentTypes === 'object') {
    return Object.values(paymentTypes).join(", ");
  }
  
  // Handle old string format for backward compatibility
  if (typeof paymentTypes === 'string') {
    return paymentTypes.split(";").join(", ");
  }

  return "N/A";
};

export default function StationDetails({
  station,
  isOpenModal,
  setOpenModal,
  onGetDirectionsClick,
  handleAddToTrip,
}) {
  const [openContactModal, setOpenContactModal] = React.useState(false);
  const [IsEmail, setIsEmail] = useState(false);
  const [stationImages, setStationImages] = useState([]);
  const [stationImagesMap, setStationImagesMap] = useState({});

  const handleCloseContactModal = () => setOpenContactModal(false);

  const handleCloseModal = () => setOpenModal(false);

  const handleDirectionsClick = () => {
    onGetDirectionsClick(station); // Send the station data)
    handleCloseModal(); // Optionally close the modal
  };

  const handleAddToTripButtonClick = () => {
    handleAddToTrip(station);
    handleCloseModal();
  };

  useEffect(() => {
    // Fetch images from API
    const loadStationImages = async () => {
      const data = await fetchStationImages();
      setStationImagesMap(data);
    };

    loadStationImages();
  }, []);

  useEffect(() => {
    // Get images from fetched API data
    const stationId = station?.StationIdNumber;
    const imageUrl = stationImagesMap[stationId];

    if (imageUrl) {
      // Single image available
      setStationImages([imageUrl]);
    } else {
      // No image available
      setStationImages([]);
    }
  }, [station?.StationIdNumber, stationImagesMap]);
  console.log("Station==>", stationImagesMap[station?.StationIdNumber] );

  return (
    <Modal
      open={isOpenModal}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="station-details-section">
        {stationImages?.length > 1 ? (
          <SwiperCarousel images={stationImages} />
        ) : (
          <Box className="station-details-img">
            <img
              src={stationImagesMap[station?.StationIdNumber] || Station}
              alt={Station}
            />
          </Box>
        )}
        <Box className="station-details-close-icon" onClick={handleCloseModal}>
          <IconButton>
            <Close sx={{ fontSize: "1rem", color: "#fff" }} />
          </IconButton>
        </Box>
        <Box className="station-details">
          <Typography variant="h3">
            {station?.Street}, {station?.StationCity},{" "}
            {station?.StationState} {station?.StationZipcode}
          </Typography>
          {/* <Typography variant="body2">
            Station Id & Station Number Id:{" "}
            {
              // capitalizeEachWord(
              station?.StationIdNumber ||
                // )
                "N/A"
            }
            ,{" "}
            {station?.StationId ||
              // )
              "N/A"}
          </Typography> */}
          <Typography
            className="hourlyOpenAndAccepts"
            sx={{ marginBottom: "10px" }}
          >
            Station number:
            <span style={{ marginLeft: "5px" }}>
              {station?.StationIdNumber || "N/A"}
            </span>
          </Typography>
          <Typography
            className="hourlyOpenAndAccepts"
            sx={{ marginBottom: "10px" }}
          >
            Hours:
            <span style={{ marginLeft: "5px" }}>
              {station?.HoursOpen?.replace(/none|None|;/gi, " ") || "N/A"}
            </span>
          </Typography>
          <Typography className="hourlyOpenAndAccepts">
            Accepts:
            <span style={{ marginLeft: "5px", lineHeight: 0.5 }}>
              {formatPaymentTypes(station?.PaymentTypes)}
            </span>
          </Typography>
          <Box className="station-wrap">
            <Box className="station-status">
              <Typography variant="h4">Station status</Typography>
              <Typography variant="body2" sx={{ marginBottom: 0 }}>
                {(station?.StationStatus === "Active" && "Operational") ||
                  station?.StationStatus}
              </Typography>
            </Box>

            <Box className="station-status">
              <Typography variant="h4">Fuel types</Typography>
              <Typography variant="body2" sx={{ marginBottom: 0 }}>
                {[
                  station?.StationFuelTypeCNG === "Yes" && "CNG",
                  station?.StationFuelTypeLNG === "Yes" && "LNG",
                ]
                  .filter(Boolean)
                  .join(", ")}
              </Typography>
            </Box>
            <Box className="station-status">
              <Typography variant="h4">Max. vehicle size</Typography>
              <Typography variant="body2" sx={{ marginBottom: 0 }}>
                {[
                  station?.VehicleTypesBoxTrucks === "Yes" &&
                    "Box trucks",
                  station?.VehicleTypesCarsAndVans === "Yes" &&
                    "Cars and vans",
                  station?.VehicleTypesSemiTrucks === "Yes" &&
                    "Semi trucks",
                ]
                  .filter(Boolean)
                  .join(", ")}
              </Typography>
            </Box>

            <Box className="station-status">
              <Typography variant="h4">Station Type</Typography>
              <Typography variant="body2" sx={{ marginBottom: 0 }}>
                {station?.StationStatus === "Active" ? "Operational" : station?.StationStatus}
              </Typography>
            </Box>
          </Box>

          <Box className="btn-station">
            <Button onClick={handleDirectionsClick}>Get directions</Button>
            <Button onClick={handleAddToTripButtonClick}>Add to trip</Button>
            <ContactModal
              openContactModal={openContactModal}
              handleCloseContactModal={handleCloseContactModal}
              station={station}
              IsEmail={IsEmail}
            />
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
